<script setup lang="ts">
import type { PurchaseResponse, EventResponse } from '@@/types/api';
import { isTicketSalesClosed } from '~/utils/event-policy';

const props = defineProps<{
  purchase: PurchaseResponse;
  event: EventResponse;
}>();

const canPurchaseAdditional = computed(
  () =>
    props.event.user_facing_status === 'Confirmed' &&
    !(props.event.is_sold_out ?? false) &&
    !isTicketSalesClosed(props.event),
);

const emit = defineEmits<{
  'purchase-additional': [];
}>();
</script>

<template>
  <div class="attendee-status-card">
    <div class="d-flex align-center mb-3">
      <v-icon color="success" class="mr-2">mdi-check-circle</v-icon>
      <span class="text-subtitle-1 font-weight-bold">You have a ticket</span>
    </div>

    <p class="text-body-2 text-medium-emphasis mb-4">
      Your ticket for this event is confirmed.
    </p>

    <!-- Payment method summary -->
    <div
      v-if="purchase.card_last_four"
      class="d-flex align-center mb-3 pa-3 rounded-lg bg-surface-variant"
    >
      <v-icon size="small" class="mr-2">mdi-credit-card-outline</v-icon>
      <span class="text-body-2">
        Card &bull;&bull;&bull;&bull; {{ purchase.card_last_four }}
      </span>
      <v-spacer />
      <span
        v-if="purchase.card_exp_month != null && purchase.card_exp_year != null"
        class="text-body-2 text-medium-emphasis"
      >
        {{ String(purchase.card_exp_month).padStart(2, '0') }}/{{
          purchase.card_exp_year
        }}
      </span>
    </div>

    <v-btn
      v-if="canPurchaseAdditional"
      variant="outlined"
      size="small"
      color="primary"
      block
      @click="emit('purchase-additional')"
    >
      Buy additional tickets
    </v-btn>
  </div>
</template>
